// validacioones de de CODE
export function validate_chile(rut) {
  var digit, i, mult_nums, rest, reverse_str, rut_digit, rut_reversed, rut_splited, rut_to_process, total, ver_digit, _i, _len;
  if (typeof rut === "undefined") {
    return false;
  }
  rut = rut.toLowerCase().replace(/[\.\-]/g, '');
  reverse_str = function(str) {
    return str.split('').reverse().join('');
  };
  rut_digit = rut.substr(rut.length - 1);;
  rut_splited = rut.substr(0, rut.length - 1);



  rut_reversed = reverse_str(rut_splited);
  mult_nums = [2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7];
  rut_to_process = rut_reversed.split("");
  total = 0;
  for (i = _i = 0, _len = rut_to_process.length; _i < _len; i = ++_i) {
    digit = rut_to_process[i];
    total = total + (digit * mult_nums[i]);
  }
  rest = total % 11;
  ver_digit = 11 - rest;
  if (ver_digit === 11) {
    ver_digit = 0;
  } else if (ver_digit === 10) {
    ver_digit = "k";
  }
  if (rut_digit === ver_digit || parseInt(rut_digit) === ver_digit) {
    return true;
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/config/validators.js